const BASE_URL = '/api/workspace/'

export interface WorkspaceParam {
  user: WorkspaceUser
  workspaceId: string
  wsUserKey?: string
  workspace?: Workspace
  curation?: Curation
  curationId?: string
  lastUpdated?: number
  patch?: CurationPatch
}

export const useWorkspace = () => {
  const { fetchGet, fetchPost, fetchPostForm } = useCustomFetch()
  const { searchCuration } = useCuration()

  //通常ワークスペースAPI
  function getWorkspace(id: string): Promise<Workspace> {
    return fetchGet(BASE_URL + id)
  }

  function updateWorkspace(ws: Workspace) {
    return fetchPost(BASE_URL + 'update', ws)
  }

  function createWorkspace(ws: Workspace): Promise<Workspace> {
    return fetchPost(BASE_URL + 'create', ws)
  }

  function deleteWorkspace(ws: Workspace): Promise<Workspace> {
    return fetchPost(BASE_URL + ws.id + '/delete')
  }

  function searchWorkspace(q: SearchQuery): Promise<SearchResult<Workspace>> {
    return fetchGet(BASE_URL + 'search' + toSearchQueryString(q))
  }

  function searchCurationInWorkspace(
    ws: Workspace,
  ): Promise<SearchResult<Curation>> {
    const query: SearchQuery = {}
    query.filter = { workspace: [ws.id] }
    query.permission = 'O'
    query.size = 2000
    return searchCuration(query)
  }

  //個人用ワークスペースAPI
  function getPersonalWorkspaceCurations(
    id: string,
    workspaceKey: string,
  ): Promise<Curation[]> {
    return fetchPostForm(BASE_URL + 'personal/get-curations', {
      id,
      workspaceKey,
    })
  }

  function postCurationsToPersonalWorkspace(
    workspaceId: string,
    workspaceKey: string,
    curations: Curation[],
  ): Promise<void> {
    return fetchPost(BASE_URL + 'personal/upload-curations', {
      workspaceId,
      workspaceKey,
      curations,
    })
  }

  function createPersonalWorkspace(ws: Workspace): Promise<Workspace> {
    return fetchPost(BASE_URL + 'personal/create', ws)
  }

  function deletePersonalWorkspace(
    id: string,
    workspaceKey: string,
  ): Promise<void> {
    return fetchPostForm(BASE_URL + 'personal/delete', { id, workspaceKey })
  }

  //WorkspaceState関連API

  function loginWorkspace(p: WorkspaceParam): Promise<WorkspaceState> {
    return fetchPost(BASE_URL + 'login', p)
  }

  function syncWorkspaceUser(p: WorkspaceParam): Promise<WorkspaceState> {
    return fetchPost(BASE_URL + 'sync-user', p)
  }

  function syncWorkspaceState(p: WorkspaceParam): Promise<WorkspaceState> {
    return fetchPost(BASE_URL + 'sync', p)
  }

  /**
   *
   * @param p workspaceId, user.id, wsUserKeyが必要
   */
  function logoutWorkspace(p: WorkspaceParam): Promise<void> {
    return fetchPost(BASE_URL + 'logout', p)
  }

  function banWorkspaceUser(p: WorkspaceParam): Promise<WorkspaceState> {
    return fetchPost(BASE_URL + 'ban', p)
  }

  function getStateWorkspace(p: WorkspaceParam): Promise<Workspace> {
    return fetchPost(BASE_URL + 'get-workspace', p)
  }

  function syncWorkspace(p: WorkspaceParam): Promise<WorkspaceState> {
    return fetchPost(BASE_URL + 'update-workspace', p)
  }

  function addWorkspaceCuration(p: WorkspaceParam): Promise<CurationUpdates> {
    return fetchPost(BASE_URL + 'add-curation', p)
  }

  function deleteWorkspaceCuration(
    p: WorkspaceParam,
  ): Promise<CurationUpdates> {
    return fetchPost(BASE_URL + 'delete-curation', p)
  }

  function syncWorkspaceCuration(p: WorkspaceParam): Promise<CurationUpdates> {
    return fetchPost(BASE_URL + 'sync-curation', p)
  }

  function syncWorkspaceCurationPatch(
    p: WorkspaceParam,
  ): Promise<CurationPatch[]> {
    return fetchPost(BASE_URL + 'sync-curation-patch', p)
  }

  function updateWorkspaceCuration(
    p: WorkspaceParam,
  ): Promise<CurationUpdates> {
    return fetchPost(BASE_URL + 'update-curation', p)
  }

  function searchWorkspaceCuration(
    p: WorkspaceParam,
    query: SearchQuery,
  ): Promise<SearchResult<Curation>> {
    return fetchPost(
      BASE_URL + 'search-curation' + toSearchQueryString(query),
      p,
    )
  }

  return {
    getWorkspace,
    updateWorkspace,
    createWorkspace,
    deleteWorkspace,
    searchWorkspace,
    searchCurationInWorkspace,
    getPersonalWorkspaceCurations,
    postCurationsToPersonalWorkspace,
    createPersonalWorkspace,
    deletePersonalWorkspace,
    loginWorkspace,
    syncWorkspaceUser,
    syncWorkspaceState,
    logoutWorkspace,
    banWorkspaceUser,
    getStateWorkspace,
    syncWorkspace,
    addWorkspaceCuration,
    deleteWorkspaceCuration,
    syncWorkspaceCuration,
    syncWorkspaceCurationPatch,
    updateWorkspaceCuration,
    searchWorkspaceCuration,
  }
}
